import axios from "axios";

export const apiClient = axios.create({
  baseURL: "https://applport.globsolutions.in",
});

export const getDocument = (token) =>
  apiClient.get("/certificate", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getCourse = (token) =>
  apiClient.get("/courses", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const AssignDocument = (courseId, assignmentDTO, token) =>
  apiClient.post(`/courses/${courseId}/assign-documents`, assignmentDTO, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllCourseDocuments = (token) =>
  apiClient.get("/course-documents", {
    headers: { Authorization: `Bearer ${token}` },
  });


  export const updateDocumentsForCourse = (courseId, token, updatedAssignmentDTO) =>
      apiClient.put(
          `/courses/${courseId}/update-documents`,
          updatedAssignmentDTO,
          {
              headers: { Authorization: `Bearer ${token}` },
          }
      );